import { Row, Col, } from 'react-bootstrap'
import Website from '../../../assests/web-service-icon.svg'
import Blockchain from '../../../assests/blockchain-service-icon.png'
import Mobile from '../../../assests/mobile-servcie-icon.png'
import Cloud from '../../../assests/cloud-service-icon.png'
import servicebg4 from "../../../assests/servicebg4.png"
import Service from '../../common/service';
import { useTranslation } from 'react-i18next';

import './services.css'

function Services() {
    const { t } = useTranslation();
    const services = [
        {
            href: '/blockchain',
            icon: Blockchain,
            alt: 'Blockchain development service icon',
            heading: t('blockchain'),
        },
        {
            href: '/cloud',
            icon: Cloud,
            alt: 'Cloud infrastructure service icon',
            heading: t('cloudservices'),
        },
        {
            href: '/mobile-development',
            icon: Mobile,
            alt: 'Mobile app development service icon',
            heading: t('mobileapp'),
        },
        {
            href: '/web',
            icon: Website,
            alt: 'Web development service icon',
            heading: t('webServices'),
        },
    ];

    return (
        <section className="service-section" aria-labelledby="home-services-heading">
            <Row className=''>
                <Col>
                    <h2 id="home-services-heading" className='services-heading d-flex justify-content-center'>{t("ourservices")}</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className='text-white px-5 '>
                        {t("ourservicessubtext")}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className='' lg={5} sm={12}>
                    <img className='servicebgimg' src={servicebg4} alt="Illustration of BringIt Go digital service planning" loading="lazy" decoding="async" />
                </Col>
                <Col lg={7} sm={12}>
                    <Row as="ul" className="services-list">
                        {services.map((service) => (
                            <Col as="li" className='d-flex justify-content-center' md={6} sm={12} key={service.href}>
                                <a className="service-link" href={service.href} aria-label={`Learn more about ${service.heading}`}>
                                    <Service
                                        icon={service.icon}
                                        alt={service.alt}
                                        serviceHeading={service.heading}
                                    />
                                </a>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            {/* <Row className="justify-content-center">
                <Col md={6}>
                    <Service
                        icon={UIUX}
                        alt={'UIUX Icon'}
                        serviceHeading={t('uxui')}
                        serviceDetails={t('uiuxservicedescription')}
                    />
                </Col>
            </Row> */}
        </section>
    )
}

export default Services
